import { PropertyDataAP } from './components/PropertyDataAP';

export const StepTwo = () => <PropertyDataAP />;
